import { RecentlyViewed } from "@theme/recently-viewed-products";

/**
 * Initialize recently viewed product tracking
 * Automatically tracks the current product when on a product page
 */
function initRecentlyViewedTracker() {
  const productElement = document.querySelector('#pdp__data');
  if (productElement) {
    const productId = productElement?.dataset.productId;
    if (productId) {
      RecentlyViewed.addProduct(productId);
    }
  }
}

// Auto-initialize when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRecentlyViewedTracker);
} else {
  initRecentlyViewedTracker();
}

export default initRecentlyViewedTracker;
